module.exports = __webpack_public_path__ + "img/steam-zh.b6e93942.png";